import React, {useEffect, useState} from "react";
import cn from "classnames";
import styles from "./User.module.sass";
import Icon from "../../../components/Icon";
import Report from "../../../components/Report";
import Modal from "../../../components/Modal";
import CopyButton from "../../../components/CopyButton";
import ShortenAddress from "../../../components/ShortenAddress";
import moment from "moment";


const socials = [];

const User = ({className, user}) => {
    const [visibleModalReport, setVisibleModalReport] = useState(false);

    useEffect(() => {
        if (user.insta) {
            socials.push({
                title: "instagram",
                url: user.insta,
                viewBox: "0 0 16 16"
            })
        }
        if (user.tweet) {
            socials.push({
                title: "twitter",
                url: user.tweet,
                viewBox: "0 0 16 16"
            })
        }
    }, [])

    const useCloudinaryUrl = url => {
        if (url.indexOf('cloudinary.com') === -1) return url;

        return url.replace('upload/', 'upload/b_rgb:' + process.env.REACT_APP_IMG_BG + ',c_pad,h_160,w_160/')
    }

    return (
        <>
            <div className={cn(styles.user, className)}>
                <div className={styles.avatar}>
                    <img src={useCloudinaryUrl(user.avatar)} alt="Avatar"/>
                </div>
                <div className={styles.name}>{user.username}</div>
                <div className={styles.code}>
                    <ShortenAddress address={user.address}/>
                    <CopyButton text={user.address}/>
                </div>
                <div className={styles.info}>{user.description}</div>
                {user.link &&
                <a className={styles.site}
                   href={window.location.protocol + '//' + window.location.host + '/profile/' + user.link}>
                    <Icon name="globe" size="16"/>
                    <span>{window.location.protocol + '//' + window.location.host + '/profile/' + user.link}</span>
                </a>
                }


                {user &&
                <div className={styles.socials}>
                    {socials.map((x, index) => (
                        <a
                            className={styles.social}
                            href={x.url}
                            target="_blank"
                            rel="noopener noreferrer"
                            key={index}
                        >
                            <Icon name={x.title} size="24" viewBox={x.viewBox}/>
                        </a>
                    ))}
                </div>
                }


                {/*<div className={styles.control}>
                    <div className={styles.btns}>
                        <button
                            className={cn(
                                "button button-small",
                                {[styles.active]: visible},
                                styles.button
                            )}
                            onClick={() => setVisible(!visible)}
                        >
                            <span>Follow</span>
                            <span>Unfollow</span>
                        </button>
                        <button
                            className={cn(
                                "button-circle-stroke button-small",
                                {[styles.active]: visibleShare},
                                styles.button
                            )}
                            onClick={() => setVisibleShare(!visibleShare)}
                        >
                            <Icon name="share" size="20"/>
                        </button>
                        <button
                            className={cn("button-circle-stroke button-small", styles.button)}
                            onClick={() => setVisibleModalReport(true)}
                        >
                            <Icon name="report" size="20"/>
                        </button>
                    </div>
                    <div className={cn(styles.box, {[styles.active]: visibleShare})}>
                        <div className={styles.stage}>Share link to this page</div>
                        <div className={styles.share}>
                            <TwitterShareButton
                                className={styles.direction}
                                url={shareUrlTwitter}
                            >
                <span>
                  <Icon name="twitter" size="20"/>
                </span>
                            </TwitterShareButton>
                            <FacebookShareButton
                                className={styles.direction}
                                url={shareUrlFacebook}
                            >
                <span>
                  <Icon name="facebook" size="20"/>
                </span>
                            </FacebookShareButton>
                        </div>
                    </div>
                </div>
                <div className={styles.socials}>
                    {item.map((x, index) => (
                        <a
                            className={styles.social}
                            href={x.url}
                            target="_blank"
                            rel="noopener noreferrer"
                            key={index}
                        >
                            <Icon name={x.title} size="20"/>
                        </a>
                    ))}
                </div>*/}
                <div className={styles.note}>Member since {moment(user.created_at * 1000).format('ll')}</div>
            </div>
            <Modal
                visible={visibleModalReport}
                onClose={() => setVisibleModalReport(false)}
            >
                <Report/>
            </Modal>
        </>
    );
};

export default User;
